import Title from "Components/Title";

const SendUsStorySuccess = () => {
  return <Title type="success">Thank you! We received your story.</Title>;
};

export default SendUsStorySuccess;
